// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyArLwOujau5CCe6Uq4x-ZArXzrV-zJ0L5A",
  authDomain: "deepak-portfolio-b9d86.firebaseapp.com",
  projectId: "deepak-portfolio-b9d86",
  storageBucket: "deepak-portfolio-b9d86.appspot.com",
  messagingSenderId: "975786652453",
  appId: "1:975786652453:web:014c13e3f652af2e0d60cc"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db  = getFirestore()